const prefix = 'phone-2.0';

const components = {
  voicemail: 'voicemail',
  recentCalls: 'recent-calls',
};

export const trackingId = ({ component, context }: { component: keyof typeof components; context: string }) => {
  return `${prefix}::${components[component]}::${context}`;
};

const transcriptionSubcomponents = {
  table: 'table',
  panel: 'panel',
};

export const transcriptionTrackingId = ({
  subComponent,
  context,
}: {
  subComponent: keyof typeof transcriptionSubcomponents;
  context: string;
}) => {
  return trackingId({ component: 'voicemail', context: `${transcriptionSubcomponents[subComponent]}::${context}` });
};

export const voicemailTrackingId = ({ context }: { context: string }) => {
  return trackingId({ component: 'voicemail', context });
};

export const recentCallsTrackingId = ({ context }: { context: string }) => {
  return trackingId({ component: 'recentCalls', context });
};
